import * as dataUtils from '../utils/dataUtils';
import * as environmentUtils from '../utils/environmentUtils';

import baseConfig from './config.base';
import configurationLoader from './configLoader';


const environment = environmentUtils.getEnvironment();
const environmentConfiguration = configurationLoader(environment);

const config = dataUtils.merge(baseConfig, environmentConfiguration);


export default config;
